export default "__VITE_ASSET__qxOndNuy__"